import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectIsAuthenticated } from '../../store/slices/authSlice';

/**
 * ProtectedRoute — wrap any route element that requires authentication.
 *
 * Usage:
 *   <Route
 *     path="/account"
 *     element={
 *       <ProtectedRoute>
 *         <AccountPage />
 *       </ProtectedRoute>
 *     }
 *   />
 *
 * Unauthenticated visitors are bounced to /signin with a `from` query
 * param so the SignIn page can return them to where they were going.
 */
export default function ProtectedRoute({ children }) {
  const isAuth = useSelector(selectIsAuthenticated);
  const location = useLocation();

  if (!isAuth) {
    const from = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/signin?from=${from}`} replace />;
  }

  return children;
}
